import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#000";
function LL({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg viewBox="0 0 1200 1200" height={size} width={size} fill={color}><path d="M515.156 608.41c-15.329 15.328-15.329 40.774 0 56.41l112.82 112.82a39.783 39.783 0 0056.411 0c15.33-15.329 15.33-40.775 0-56.41l-112.82-112.82c-15.33-15.33-40.775-15.33-56.41 0" /><path d="M898.685 563.342a39.783 39.783 0 000-56.41c-15.329-15.329-40.775-15.329-56.41 0L684.387 664.82l-28.205 28.205c-34.95 34.95-82.776 29.431-98.412 14.102l70.207 70.207c15.329 15.329 40.775 15.329 56.41 0zm-213.378-10.73c15.329-15.329 15.329-40.775 0-56.41L572.487 383.38a39.783 39.783 0 00-56.411 0c-15.329 15.329-15.329 40.775 0 56.41l112.82 112.821c15.636 15.329 40.775 15.329 56.41 0" /><path d="M301.778 597.986a39.783 39.783 0 000 56.41c15.329 15.329 40.775 15.329 56.41 0l157.888-158.194 28.205-28.206c34.95-34.95 82.776-29.431 98.412-14.102l-70.207-70.206c-15.329-15.33-40.775-15.33-56.41 0z" /></Svg>;
}
LL.DefaultColor = DefaultColor;
export default LL;